import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import withHooks from '../../core/withHooks';
import LoginController from './login.controller';
import ResetPassword from '../reset-password/reset-password';
import { Button as AntButton, Input as AntInput } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import styles from './styles/login.module.scss';

/**
 * @extends ClockoutController
 * @extends LoginController
 * @extends Component
 */
class Login extends Inherit(LoginController, Component) {
    state = {
        email: '',
        password: '',
        loading: false,
        error: false,
        showResetPassword: false
    };

    render() {
        const { email, password, error, loading, showResetPassword } = this.state;

        if (showResetPassword) {
            return <ResetPassword />;
        }

        // Show regular login form
        return (
            <div className={styles.loginContainer}>
                <div className={styles.leftSection}>
                    <div className={styles.logoContainer}>
                        <img src="/logo-dark.png" alt="Clockout Logo" className={styles.logo} />
                    </div>
                    <div className={styles.loginCard}>
                        <h1 className={styles.title}>Sign in to your Clockout account</h1>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Email</label>
                            <AntInput
                                size="large"
                                prefix={<MailOutlined className={styles.inputIcon} />}
                                type="email"
                                value={email || ''}
                                onChange={(e) => this.setEmail(e.target.value)}
                                onPressEnter={() => !loading && email && password && this.authenticateUser()}
                                placeholder="email"
                                status={error ? 'error' : ''}
                                className={styles.input}
                                autoComplete="email"
                            />
                        </div>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Password</label>
                            <AntInput.Password
                                size="large"
                                prefix={<LockOutlined className={styles.inputIcon} />}
                                value={password || ''}
                                onChange={(e) => this.setPassword(e.target.value)}
                                onPressEnter={() => !loading && email && password && this.authenticateUser()}
                                placeholder="password"
                                status={error ? 'error' : ''}
                                className={styles.input}
                                autoComplete="current-password"
                            />
                        </div>
                        <div className={styles.forgotPasswordContainer}>
                            {/* <a href="/reset-password" className={styles.forgotPassword}>
                                Forgot your password?
                            </a> */}
                        </div>
                        <AntButton type="primary" size="large" loading={loading} onClick={() => this.authenticateUser()} className={styles.signInButton} block>
                            Sign in
                        </AntButton>
                        <div className={styles.signupContainer}>
                            {/* <span className={styles.signupText}>New to Clockout? </span>
                            <a href="/signup" className={styles.signupLink}>Sign up</a> */}
                        </div>
                    </div>
                </div>
                <div className={styles.rightSection}>
                    <div className={styles.whitepaperContainer}>
                        <div className={styles.whitepaperHeader}>
                            <span className={styles.whitepaperLabel}>FALL WHITE-PAPER RELEASE</span>
                        </div>
                        <h2 className={styles.whitepaperTitle}>Winning the Deposit Race: How Earned Wage Access Drives Growth</h2>
                        <div className={styles.whitepaperImage}>
                            <img src="/login-whitepaper-link.png" alt="Winning the Deposit Race Whitepaper" className={styles.whitepaperImg} />
                        </div>
                        <a href="https://www.joinclockout.com/whitepapers" className={styles.whitepaperLink}>
                            See all of our white-papers →
                        </a>
                    </div>
                </div>
                <div className={styles.footer}>
                    <span className={styles.copyright}>Copyright © 2025 Clockout Financial Inc.</span>
                    <div className={styles.footerLinks}>
                        <a href="/terms" className={styles.footerLink}>
                            Terms and Conditions
                        </a>
                        <a href="/privacy" className={styles.footerLink}>
                            Privacy Policy
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default withHooks(Login);
